import article from './article';
import product from './product';
import productCompare from './product-compare';
import productAlert from './product-alert';
import start from './start';
import category from './category';
import store from './store';
import campaign from './campaign';
import infoPage from './info-page';
import brand from './brand';
import services from './services';
import login from './login';
import shopOfTheYearLandingPage from './shop-of-the-year-landing-page';
import shopOfTheYearCategory from './shop-of-the-year-category';
import shopOfTheYearWinners from './shop-of-the-year-winners';
import shopOfTheYear from './shop-of-the-year';
import search from './search';
import generic from './generic';
import productCollection from './product-collection';
import productCollectionSitemap from './product-collection-sitemap';
import editorialContent from './editorial-content';
import editorialContentListing from './editorial-content-listing';
import userProfile from './user-profile';
import publicList from './public-list';

export default {
  article,
  product,
  productCompare,
  productAlert,
  start,
  category,
  store,
  campaign,
  infoPage,
  brand,
  services,
  login,
  shopOfTheYearLandingPage,
  shopOfTheYearCategory,
  shopOfTheYearWinners,
  shopOfTheYear,
  search,
  generic,
  productCollection,
  productCollectionSitemap,
  editorialContent,
  editorialContentListing,
  userProfile,
  publicList,
};
